// Keys must match src/Preferences.php.
export const PREF = {
  pauseAll: 'happyNotify_pauseAll',
  snoozeUntil: 'happyNotify_snoozeUntil',
  muteAlerts: 'happyNotify_muteAlerts',
  sleepEnabled: 'happyNotify_sleepEnabled',
  sleepStart: 'happyNotify_sleepStart',
  sleepEnd: 'happyNotify_sleepEnd',
  sleepDays: 'happyNotify_sleepDays',
  timezone: 'happyNotify_timezone',
};

export const ALL_DAYS = [0, 1, 2, 3, 4, 5, 6];

// Monday-first display order; values stay 0 = Sunday to match PHP 'w'.
export const DISPLAY_DAYS = [1, 2, 3, 4, 5, 6, 0];

export function readPref(user, key, fallback) {
  const prefs = user.preferences() || {};

  return prefs[key] === undefined || prefs[key] === null ? fallback : prefs[key];
}

function browserTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch (e) {
    return null;
  }
}

/**
 * Save preference changes. The browser timezone travels with every save so
 * sleep mode is evaluated in the user's local time on the server.
 */
export function savePrefs(user, changes) {
  const timezone = browserTimezone();

  return user.savePreferences(timezone ? { ...changes, [PREF.timezone]: timezone } : { ...changes });
}

export function nowSeconds() {
  return Math.floor(Date.now() / 1000);
}
